import React, {useRef, useEffect} from 'react'

const themes = [
    { title: 'default', value: 'default', className: 'default-theme-item' },
    { title: 'black white', value: 'black-white', className: 'black-white-theme-item' },
    { title: 'white black', value: 'white-black', className: 'white-black-theme-item' },
    { title: 'black yellow', value: 'black-yellow', className: 'black-yellow-theme-item' },
    { title: 'yellow black', value: 'yellow-black', className: 'yellow-black-theme-item'},
];

export const ThemeList = ({onThemeChanged, setThemesOpen, theme}) => {

    let themeRef = useRef(null);

    useEffect( () => {
        if( themeRef && themeRef.current) {
            themeRef.current.focus();
        }
    }, []);

    const onThemeItemClicked = (theme) => {
        //onThemeChanged(theme);
        document.documentElement.className = '';
        document.documentElement.classList.add(`theme-${theme}`);
        setThemesOpen(false)
    }

    const onKeyDownHandle = (e, func, arg, i) => {
        let key = e.key || e.keyCode;
        if(key === 13 || key === 'Enter'){
            func(arg)
            window.document.querySelector('#contrast1').focus()
        }
        let isShift;
        if (window.event) {
          isShift = !!window.event.shiftKey;
        } else {
          isShift = !!e.shiftKey;
        }
        if( (key === 9 || key === 'Tab') && !isShift){
            if (i === (themes.length - 1)){
                e.preventDefault();
                let items = window.document.querySelectorAll('.theme-item')
                if (items.length > 0){
                    items[0].focus()
                }
                //setThemesOpen(false)
                //window.document.getElementById('contrast1').focus()
            }
        }
        if ( (key === 9 || key === 'Tab') && isShift && i === 0){
            e.preventDefault()
            let items = window.document.querySelectorAll('.theme-item')
            if (items.length > 0){
                items[items.length - 1].focus()
            }
        }
    }

    return(
        <div className = {`theme-list theme-${theme}`}>
            {
                themes.map(({value, title, className}, i) => (
                    <div key = {i} className={`theme-item `}
                        tabIndex = {0}
                        ref = {i === 0 ? themeRef : null}
                        onClick = { () => onThemeItemClicked(value) }
                        onKeyDown = { (e) => onKeyDownHandle(e, onThemeItemClicked, value, i) }
                    >
                        <div className = {`theme-indicator ${className}`}></div>
                        {title}
                    </div>
                ))
            }
        </div>
    )
}

